import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import api from "services/api";
// import auth from "services/auth";
// import AppContext from "contexts/AppContext";
import moneyFormatter from "services/moneyFormatter";
import ls from "services/ls";
import config from "configs/config";
// import { isMobile } from "services/isMobile";
import FiatDeposit from "elements/dashboard_elements/FiatDeposit";
import FiatWithdrawals from "elements/dashboard_elements/FiatWithdrawals";

import {
  Modal,
  Alert,
  Dropdown,
  Form,
  Overlay,
  Tooltip,
  Tabs,
  Tab,
} from "react-bootstrap";
import { __ } from "services/Translator";
import swal from "sweetalert";

function CashierModals(props) {
  const userBalance = props.userBalance;
  const getUserBalance = props.getUserBalance;
  const setUsersWallet = props.setUsersWallet;
  const showInPlay = false;
  const [show, setShow] = useState(false);
  const target = useRef(null);
  const wageringTooltipRef = useRef(null);
  const [wageringTooltipShow, setWageringTooltipShow] = useState(false);
  const tagRef = useRef(null);
  const [tagShow, setTagShow] = useState(false);
  const fiatMethods = ["USD"];

  const minDeposits = {
    BTC: 0.0001,
    ETH: 0.01,
    BNB: 0.01,
    LTC: 0.01,
    DOGE: 1,
    USDTE: 0.01,
    USDTT: 1,
    TRX: 10,
    XRP: 0.001,
  };
  const confirmationsRequired = {
    BTC: 1,
    ETH: 10,
    BNB: 1,
    LTC: 6,
    DOGE: 6,
    USDTE: 10,
    USDTT: 19,
    TRX: 19,
    XRP: 3,
  };

  useEffect(() => {
    var timeout;
    if (wageringTooltipShow) {
      timeout = setTimeout(() => {
        setWageringTooltipShow(false);
      }, 3000);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [wageringTooltipShow]);

  const copyDepositAddress = () => {
    var copyText = document.getElementById("deposit_address");
    navigator.clipboard.writeText(copyText.value);
    setShow(true);
    const timer = setTimeout(() => {
      setShow(false);
    }, 2000);
    return () => clearTimeout(timer);
  };

  const copyDepositTag = () => {
    var copyText = document.getElementById("deposit_tag");
    navigator.clipboard.writeText(copyText.value);
    setTagShow(true);
    const timer = setTimeout(() => {
      setTagShow(false);
    }, 2000);
    return () => clearTimeout(timer);
  };

  // walletModal
  const [depositWallets, setDepositWallets] = useState([]);
  const [selectedDepositWallet, setSelectedDepositWallet] = useState("BTC");

  const [selectedWithdrawalWallet, setSelectedWithdrawalWallet] =
    useState("BTC");
  const [withdrawalWalletAddress, setWithdrawalWalletAddress] = useState("");
  const [withdrawalAmount, setWithdrawalAmount] = useState("");
  const [withdrawalTag, setWithdrawalTag] = useState("");

  const [showWalletModal, setShowWalletModal] = useState(false);
  const openWalletModal = async () => {
    if (userBalance.wallets.length) {
      setShowWalletModal(true);

      setWithdrawalMessage(null);
      setWithdrawalMessageType("success");

      if (fiatMethods.indexOf(userBalance.wallets[0].currency) === -1) {
        setSelectedDepositWallet(userBalance.wallets[0].currency);
        setSelectedWithdrawalWallet(userBalance.wallets[0].currency);
      }

      var response = await api.get("/deposit/wallets");
      if (response.status === 200) {
        setDepositWallets(response.data);
      }
      getPlayerAcceptBonuses();
    }
  };

  const closeWalletModal = () => {
    setShowWalletModal(false);
    props.setOpenWalletModalTab(null);
  };

  const [showBalanceAsFiat, setShowBalanceAsFiat] = useState(
    ls.get("showBalanceAsFiat") ? ls.get("showBalanceAsFiat") : false
  );
  const [hideEmptyWallets, setHideEmptyWallets] = useState(
    ls.get("hideEmptyWallets") ? ls.get("hideEmptyWallets") : false
  );
  const [fiatCurrencyToDisplay, setFiatCurrencyToDisplay] = useState(
    ls.get("fiatCurrencyToDisplay") ? ls.get("fiatCurrencyToDisplay") : "USD"
  );
  const [showFiatChooserModal, setShowFiatChooserModal] = useState(false);
  const toggleShowBalanceAsFiat = () => {
    if (!showBalanceAsFiat) {
      setShowFiatChooserModal(true);
    }
    ls.set("showBalanceAsFiat", !showBalanceAsFiat);
    setShowBalanceAsFiat(!showBalanceAsFiat);
    props.setTrigger(Math.random());
  };
  const toggleHideEmptyWallets = () => {
    ls.set("hideEmptyWallets", !hideEmptyWallets);
    setHideEmptyWallets(!hideEmptyWallets);
  };
  const fiatToDisplaySelected = (ev) => {
    ls.set("fiatCurrencyToDisplay", ev.target.value);
    setFiatCurrencyToDisplay(ev.target.value);
    props.setTrigger(Math.random());
  };
  const closeFiatChooserModal = () => {
    setShowFiatChooserModal(false);
  };

  const [withdrawalMessage, setWithdrawalMessage] = useState(null);
  const [withdrawalMessageType, setWithdrawalMessageType] = useState("success");

  const withdraw = async () => {
    if (!withdrawalWalletAddress) {
      setWithdrawalMessage(
        "Please enter the " +
          selectedWithdrawalWallet +
          " address for withdrawal"
      );
      setWithdrawalMessageType("danger");
      return false;
    }

    if (depositWallets[selectedWithdrawalWallet]?.tag && !withdrawalTag) {
      setWithdrawalMessage("Please enter the tag for withdrawal");
      setWithdrawalMessageType("danger");
      return false;
    }

    var amount = parseFloat(withdrawalAmount);
    if (!amount || isNaN(amount)) {
      setWithdrawalMessage("Please enter a valid amount for withdrawal");
      setWithdrawalMessageType("danger");
      return false;
    } else if (parseFloat(amount) < 50) {
      setWithdrawalMessage("Minimum amount for withdrawal is $50.00");
      setWithdrawalMessageType("danger");
      return false;
    }
    var postData = {
      amount: amount,
      method: "COINSPAID:" + selectedWithdrawalWallet,
      accNumber: withdrawalWalletAddress,
      tag: withdrawalTag,
    };
    var response = await api.post("/withdraw", {
      ...postData,
      twofa_code: twoFaCode,
    });
    if (response.status === 200) {
      setWithdrawalAmount("");
      setWithdrawalWalletAddress("");
      setWithdrawalTag("");
      setTwoFaCode("");
      setWithdrawalMessage("Your withdrawal request has been received");
      setWithdrawalMessageType("success");

      setTimeout(() => {
        setWithdrawalMessage(null);
      }, 3000);
    } else {
      props.showAlert(null, response.data.message, true);
    }
  };

  // wallet tabs
  const [activeWalletTab, setActiveWalletTab] = useState("deposit");
  const toggleWalletTab = (tabName) => {
    // if (tabName === "buy_crypto") {
    //   window.open(onRamperWidgetUrl, "_blank");
    //   return;
    // }
    setActiveWalletTab(tabName);
  };

  useEffect(() => {
    if (props.openWalletModalTab) {
      if (props.openWalletModalTab === "deposit") {
        openWalletModal();
        setActiveWalletTab("deposit");
      } else if (props.openWalletModalTab === "withdraw") {
        openWalletModal();
        setActiveWalletTab("withdraw");
      }
    }
  }, [props.openWalletModalTab]);

  useEffect(() => {
    setShowBalanceAsFiat(
      ls.get("showBalanceAsFiat") ? ls.get("showBalanceAsFiat") : false
    );
    setFiatCurrencyToDisplay(
      ls.get("fiatCurrencyToDisplay") ? ls.get("fiatCurrencyToDisplay") : "USD"
    );
  }, [props.trigger]);

  const [playerAcceptBonuses, setPlayerAcceptBonuses] = useState(false);

  const getPlayerAcceptBonuses = async () => {
    var response = await api.get("/player/accept-bonuses");
    if (response.status === 200) {
      setPlayerAcceptBonuses(response.data);
    }
  };

  const togglePlayerAcceptBonuses = async () => {
    var response = await api.post("/player/accept-bonuses");
    if (response.status === 200) {
      setPlayerAcceptBonuses(response.data);
    }
  };

  const userDetails = props.userDetails;
  const [profile, setProfile] = useState({});
  const [twoFaCode, setTwoFaCode] = useState("");
  const getProfile = async () => {
    var response = await api.get("/profile");
    if (response.status === 200) {
      setProfile(response.data);
    }
  };
  const resend2FaCode = async (ev) => {
    props.setSpinner(true);
    var response = await api.post("/resend-twofa");
    props.setSpinner(false);
    if (response.status == 200) {
      swal({
        className: "custom_swal",
        title: __("2FA code sent"),
        text: response.data.message,
        icon: "success",
      });
    }
  };

  useEffect(() => {
    getProfile();
  }, []);

  const [onRamperWidgetUrl, setOnRamperWidgetUrl] = useState(
    "https://widget.onramper.com?color=266677&apiKey="
  );

  const updateOnRamperWidgetUrl = () => {
    var url = "https://widget.onramper.com?color=266677";
    url += "&apiKey=" + config.onRamperApiKey;
    url += "&onlyGateways=Xanpool,Itez";
    url += "&supportSell=false";
    url += "&isAddressEditable=true";
    url += "&defaultCrypto=" + selectedDepositWallet;

    var cryptos = userBalance.wallets.map((item, index) => item.currency);
    var wallets = Object.entries(depositWallets)
      .filter((item) => fiatMethods.indexOf(item.currency) === -1)
      .map((item, index) => item[0] + ":" + item[1].address)
      .join(",");
    // console.log(wallets);
    url += "&onlyCryptos=" + cryptos;
    url += "&wallets=" + wallets;
    setOnRamperWidgetUrl(url);
  };

  useEffect(() => {
    updateOnRamperWidgetUrl();
  }, [activeWalletTab, depositWallets, selectedDepositWallet]);

  useEffect(() => {
    setBankDepositUrl(null);
  }, [activeWalletTab]);

  const [bankDepositAmount, setBankDepositAmount] = useState("");
  const [bankDepositUrl, setBankDepositUrl] = useState(null);

  const initBankDeposit = async () => {
    var url = "/cashier/payop/invoice/create";
    var data = { amount: bankDepositAmount };
    var response = await api.post(url, data);

    if (response.status === 200) {
      var bankUrl =
        "https://checkout.payop.com/en/payment/invoice-preprocessing/" +
        response.data.invoiceId;
      window.location.href = bankUrl;
      // setBankDepositUrl(bankUrl);
    }
  };

  return (
    <>
      <div className="deposit_block">
        <Dropdown>
          <Dropdown.Toggle
            className="right wallets_dropdown"
            id="dropdown-basic1"
          >
            {!showInPlay && (
              <div className="deposit_amount">
                {!!userBalance.wallets?.length
                  ? showBalanceAsFiat
                    ? moneyFormatter.convertCurrencyToFiat(
                        userBalance.wallets[0].balance +
                          userBalance.wallets[0].bonus_balance_crypto,
                        userBalance.wallets[0].currency,
                        fiatCurrencyToDisplay
                      )
                    : parseFloat(
                        userBalance.wallets[0].balance +
                          userBalance.wallets[0].bonus_balance_crypto
                      ).toFixed(8)
                  : ""}
              </div>
            )}

            {showInPlay && (
              <div onClick={() => getUserBalance()} className="deposit_amount">
                {__("In Play")}
              </div>
            )}

            <div className="deposit_icon">
              {" "}
              {!!userBalance.wallets?.length &&
                moneyFormatter.currencyIcon(userBalance.wallets[0].currency)}
            </div>
            <div className="wallet_caret">
              <i className="fal downarrow fa-caret-down"></i>
              <i className="fal uparrow fa-caret-up"></i>
            </div>
          </Dropdown.Toggle>

          <Dropdown.Menu
            className={"wallets_menu desktop " + props.landingType}
          >
            <div className="modal_top_arrow"></div>
            <div>
              <div className="wallets_head row">
                <div className="col-6"></div>
                <div className="col-6 text-right">{__("Crypto")}</div>
              </div>

              {!!userBalance.wallets?.length &&
                userBalance.wallets.map((item, index) => {
                  if (!item.balance && hideEmptyWallets) {
                    return null;
                  }
                  return (
                    <Dropdown.Item as="button" key={index}>
                      <div
                        className="wallets_balance row"
                        key={index}
                        onClick={() => setUsersWallet(item.currency)}
                      >
                        <div className="col-6">
                          {showBalanceAsFiat
                            ? moneyFormatter.convertCurrencyToFiat(
                                item.balance,
                                item.currency,
                                fiatCurrencyToDisplay
                              )
                            : parseFloat(item.balance).toFixed(8)}
                        </div>
                        <div className="col-6 currency">
                          {moneyFormatter.currencyWithIcon(item.currency)}
                        </div>
                      </div>
                    </Dropdown.Item>
                  );
                })}

              {userBalance.bonus_balance && (
                <Dropdown.Item as="button">
                  <div className="wallets_balance row">
                    <div className="col-6">
                      {userBalance.currency +
                        "" +
                        parseFloat(userBalance.bonus_balance).toFixed(2)}
                    </div>

                    <div
                      ref={wageringTooltipRef}
                      onMouseOver={() => setWageringTooltipShow(true)}
                      onMouseOut={() => setWageringTooltipShow(false)}
                      className="col-6 text-right currency"
                    >
                      <span className="currency_icon bonusIcon">
                        <img
                          style={{ width: "20px" }}
                          src={
                            require("assets/images/icons/star-icon.svg").default
                          }
                          alt=""
                        />
                      </span>
                      <span className="currency_name">{__("BONUS")}</span>
                    </div>
                    <div className="progress_bar">
                      <div className="progress">
                        <div
                          style={{
                            width: userBalance.wagering_percentage + "%",
                          }}
                          className="progress-bar"
                        ></div>
                      </div>
                    </div>
                  </div>
                </Dropdown.Item>
              )}

              <div className="wallets_bottom ">
                <div className="wallets_switch">
                  <div className="row">
                    <div className="col-12">
                      <Form.Check
                        checked={showBalanceAsFiat}
                        type="switch"
                        onChange={toggleShowBalanceAsFiat}
                        label="Show as fiat"
                        id="show_as_fiat"
                      />
                    </div>

                    <div className="col-12">
                      <Form.Check
                        checked={hideEmptyWallets}
                        type="switch"
                        label="Hide empty wallets"
                        id="hide_empty_wallets"
                        onChange={toggleHideEmptyWallets}
                      />
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-center">
                  <div
                    className={"deposit_button d-md-none " + props.landingType}
                  >
                    <a
                      onClick={openWalletModal}
                      className="deposit_btn"
                      href="#"
                    >
                      {__("Wallet")}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </Dropdown.Menu>
        </Dropdown>

        <div
          className={"deposit_button d-none d-md-block " + props.landingType}
        >
          <a onClick={openWalletModal} className="deposit_btn" href="#">
            {__("Wallet")}
          </a>
        </div>
      </div>
      <Modal
        className="main_popup"
        show={showFiatChooserModal}
        onHide={closeFiatChooserModal}
        centered
      >
        <Modal.Body className="cashier_modal legal_area fiat_selectors_modal">
          <div
            onClick={closeFiatChooserModal}
            className="close_button text-end"
            closeButton
          >
            <i className="far fa-times"></i>
          </div>

          <div className="modal_headline">{__("Information")}</div>
          <>
            <div className="privacy_text">
              {__("Please note that these are currency approximations.")}

              {__(
                "All bets & transactions will be settled in the crypto equivalent."
              )}
              {__("For further details feel free to contact our live support.")}
            </div>

            <div className="form_area">
              <div className="form_row fiat_selectors">
                {["USD", "EUR"].map((currency, index) => (
                  <div className="fiat_select" key={index}>
                    <input
                      type="radio"
                      value={currency}
                      checked={fiatCurrencyToDisplay === currency}
                      id={"fiat_selector" + currency}
                      onChange={fiatToDisplaySelected}
                      className={props.landingType}
                    />
                    <label
                      htmlFor={"fiat_selector" + currency}
                      className="radio_area"
                    >
                      <div className="radio_check_and_text_area">
                        <div className="radio_box">
                          <div className="radio_checked_box"></div>
                        </div>
                        <div className="radio_text">
                          {moneyFormatter.currencyIcon(currency)}{" "}
                          <span className="currency">{currency}</span>
                        </div>
                      </div>
                    </label>
                  </div>
                ))}
              </div>

              <div className="login_button">
                <Link
                  to="#"
                  onClick={closeFiatChooserModal}
                  className={
                    "angle_btn small margin_0_auto " + props.landingType
                  }
                >
                  {__("Play Now")}
                </Link>
              </div>
            </div>
          </>
        </Modal.Body>
      </Modal>
      <Modal
        className="main_popup"
        size="xl"
        show={showWalletModal}
        onHide={closeWalletModal}
        centered
      >
        <Modal.Body className="cashier_modal legal_area">
          {/* <div onClick={closeWalletModal} className="close_button" closeButton>
            <i className="far fa-times"></i>
          </div> */}
          <div className="modalHeader">
            <div className="logo">
              <img
                src={
                  require("../../assets/images/new-landing/logo.png")
                }
                alt="Card-Icon"
              />
            </div>
            <div
              onClick={closeWalletModal}
              className="close_button"
              closeButton
            >
              <i className="far fa-times"></i>
            </div>
          </div>
          <br />

          <div className="row">
            <div className="col-md-5">
              <div className="badge">{__("Wallet")}</div>
              <div className="legal_img">
                <img
                  alt="Legal image"
                  src="https://chimpbytes.imgix.net/legal-popup-bg.png?&dpr=1&format=auto&auto=format&q=75&w=582&h=630&max-age=2629056"
                />
              </div>
            </div>
            <div className="col-md-7">
              <div className="tab_heading">
                <div
                  onClick={() => toggleWalletTab("deposit")}
                  className={
                    "items " +
                    (activeWalletTab === "deposit" ? "active " : " ") +
                    props.landingType
                  }
                >
                  <span
                    className={
                      activeWalletTab === "deposit"
                        ? "indicate show"
                        : "indicate"
                    }
                  ></span>
                  {__("Deposit")}
                </div>

                <div
                  onClick={() => toggleWalletTab("withdraw")}
                  className={
                    "items " +
                    (activeWalletTab === "withdraw" ? "active " : " ") +
                    props.landingType
                  }
                >
                  <span
                    className={
                      activeWalletTab === "withdraw"
                        ? "indicate show"
                        : "indicate"
                    }
                  ></span>
                  {__("Withdraw")}
                </div>

                <div
                  onClick={() => toggleWalletTab("buy_crypto")}
                  className={
                    "items " +
                    (activeWalletTab === "buy_crypto" ? "active " : " ") +
                    props.landingType
                  }
                >
                  <span
                    className={
                      activeWalletTab === "buy_crypto"
                        ? "indicate show"
                        : "indicate"
                    }
                  ></span>
                  {__("Buy Crypto")}
                </div>

                <div
                  onClick={() => toggleWalletTab("bank_deposit")}
                  className={
                    "items " +
                    (activeWalletTab === "bank_deposit" ? "active " : " ") +
                    props.landingType
                  }
                >
                  <span
                    className={
                      activeWalletTab === "bank_deposit"
                        ? "indicate show"
                        : "indicate"
                    }
                  ></span>
                  {__("Bank Deposit")}
                </div>
              </div>

              {activeWalletTab === "deposit" && (
                <>
                  <Tabs
                    defaultActiveKey="cryptocurrency"
                    id="justify-tab-example"
                    className="mb-3 cashierCustomeTabs"
                    justify
                  >
                    <Tab eventKey="cryptocurrency" title={__("Cryptocurrency")}>
                      <div className="form_area slideUpAnimation">
                        <div className="input_item">
                          <div className="name">{__("Cryptocurrency")}</div>

                          <Dropdown className="currency_select_menu">
                            <Dropdown.Toggle
                              variant="success"
                              className="right select_crypto"
                              id="dropdown-basic1"
                            >
                              <span className="dipwid vaultCryptoIcon">
                                {moneyFormatter.currencyFullWithIcon(
                                  selectedDepositWallet
                                )}
                              </span>
                            </Dropdown.Toggle>

                            <Dropdown.Menu
                              className={"wallets_menu " + props.landingType}
                            >
                              {!!userBalance.wallets?.length &&
                                userBalance.wallets
                                  .filter(
                                    (item) =>
                                      fiatMethods.indexOf(item.currency) === -1
                                  )
                                  .map((item, index) => {
                                    return (
                                      <Dropdown.Item as="button" key={index}>
                                        <div
                                          className="wallets_balance"
                                          onClick={() =>
                                            setSelectedDepositWallet(
                                              item.currency
                                            )
                                          }
                                        >
                                          {moneyFormatter.currencyFullWithIcon(
                                            item.currency
                                          )}
                                        </div>
                                      </Dropdown.Item>
                                    );
                                  })}
                            </Dropdown.Menu>
                          </Dropdown>
                          <div className="clearfix"></div>
                        </div>

                        <div className="privacy_text bordered_text">
                          {__("The minimum deposit amount for")}{" "}
                          {moneyFormatter.currencyName(selectedDepositWallet)}{" "}
                          {__("is")}{" "}
                          {moneyFormatter.currencyIcon(selectedDepositWallet)}{" "}
                          {minDeposits[selectedDepositWallet]} ($
                          {Math.ceil(
                            moneyFormatter.getFiatValue(
                              minDeposits[selectedDepositWallet],
                              selectedDepositWallet,
                              "USD"
                            )
                          ).toFixed(2)}{" "}
                          {__("approximately")}).{" "}
                          {__(
                            "Depositing a lower amount may result in a full loss of the transferred amount."
                          )}
                          {__("Only send")} {selectedDepositWallet}{" "}
                          {__("to this address")},{" "}
                          {confirmationsRequired[selectedDepositWallet]}{" "}
                          {__("confirmation")}
                          {confirmationsRequired[selectedDepositWallet] > 1
                            ? "s"
                            : ""}{" "}
                          {__("requried")}.{" "}
                          {__("We do not accept BEP20 from Binance.")}
                        </div>

                        <div className="input_item walletAddress">
                          <div className="name">
                            {selectedDepositWallet} {__("Address")}
                            <span className="requried_icon">*</span>
                          </div>
                          <input
                            type="text"
                            name="btc"
                            id="deposit_address"
                            value={
                              depositWallets[selectedDepositWallet]
                                ? depositWallets[selectedDepositWallet].address
                                : ""
                            }
                            className="input_box border_bottom "
                          />

                          <a
                            className="in_input_icon"
                            onClick={copyDepositAddress}
                            href="javascript:"
                            ref={target}
                          >
                            <img
                              alt=""
                              src={
                                require("assets/images/icons/copy-icon.svg")
                                  .default
                              }
                            />
                          </a>
                          <Overlay
                            target={target.current}
                            show={show}
                            placement="top"
                          >
                            {(props) => (
                              <Tooltip
                                id="overlay-example"
                                className="tooltip"
                                {...props}
                              >
                                {__("Copied")}
                              </Tooltip>
                            )}
                          </Overlay>
                        </div>

                        {depositWallets[selectedDepositWallet]?.tag && (
                          <div className="input_item walletAddress">
                            <div className="name">
                              {selectedDepositWallet} {__("Tag/Memo")}
                              <span className="requried_icon">*</span>
                            </div>
                            <input
                              type="text"
                              name="deposit_tag"
                              id="deposit_tag"
                              value={depositWallets[selectedDepositWallet].tag}
                              className="input_box border_bottom "
                            />

                            <a
                              className="in_input_icon"
                              onClick={copyDepositTag}
                              href="javascript:"
                              ref={tagRef}
                            >
                              <img
                                alt=""
                                src={
                                  require("assets/images/icons/copy-icon.svg")
                                    .default
                                }
                              />
                            </a>
                            <Overlay
                              target={tagRef.current}
                              show={tagShow}
                              placement="top"
                            >
                              {(props) => (
                                <Tooltip
                                  id="overlay-example"
                                  className="tooltip"
                                  {...props}
                                >
                                  {__("Copied")}
                                </Tooltip>
                              )}
                            </Overlay>
                          </div>
                        )}

                        <div className="">
                          <Form.Check
                            checked={playerAcceptBonuses}
                            type="switch"
                            onChange={togglePlayerAcceptBonuses}
                            label={__("Accept bonuses")}
                            id="accept_bonuses"
                          />
                        </div>

                        <div className="input_item">
                          <div className="qr_code in_wallet_modal">
                            <img
                              className="wallet_qr"
                              src={
                                config.apiUrl +
                                "/qr-code/" +
                                (depositWallets[selectedDepositWallet]
                                  ? depositWallets[selectedDepositWallet]
                                      .qr_text
                                  : "")
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </Tab>
                    <Tab eventKey="fiat-currency" title={__("Fiat Currency")}>
                      <div className="slideUpAnimation">
                        <FiatDeposit {...props} />
                      </div>
                    </Tab>
                  </Tabs>
                </>
              )}

              {activeWalletTab === "withdraw" && (
                <>
                  <Tabs
                    defaultActiveKey="cryptocurrencyWithdrawal"
                    id="justify-tab-example"
                    className="mb-3 cashierCustomeTabs"
                    justify
                  >
                    <Tab
                      eventKey="cryptocurrencyWithdrawal"
                      title={__("Cryptocurrency")}
                    >
                      <div className="form_area slideUpAnimation">
                        <div className="input_item">
                          <div className="name">{__("Cryptocurrency")}</div>

                          {withdrawalMessage && (
                            <Alert variant={withdrawalMessageType}>
                              {withdrawalMessage}
                            </Alert>
                          )}

                          <Dropdown className="currency_select_menu">
                            <Dropdown.Toggle
                              variant="success"
                              className="right select_crypto"
                              id="dropdown-basic1"
                            >
                              <span className="dipwid vaultCryptoIcon">
                                {moneyFormatter.currencyFullWithIcon(
                                  selectedWithdrawalWallet
                                )}
                              </span>
                            </Dropdown.Toggle>

                            <Dropdown.Menu
                              className={"wallets_menu " + props.landingType}
                            >
                              {!!userBalance.wallets?.length &&
                                userBalance.wallets
                                  .filter(
                                    (item) =>
                                      fiatMethods.indexOf(item.currency) === -1
                                  )
                                  .map((item, index) => {
                                    return (
                                      <Dropdown.Item as="button" key={index}>
                                        <div
                                          className="wallets_balance"
                                          onClick={() =>
                                            setSelectedWithdrawalWallet(
                                              item.currency
                                            )
                                          }
                                        >
                                          {moneyFormatter.currencyFullWithIcon(
                                            item.currency
                                          )}
                                        </div>
                                      </Dropdown.Item>
                                    );
                                  })}
                            </Dropdown.Menu>
                          </Dropdown>
                          <div className="clearfix"></div>
                        </div>

                        <div className="privacy_text bordered_text">
                          {__("Minimum withdrawal is $50.00.")}
                        </div>
                        <div className="input_item">
                          <div className="name">
                            {selectedWithdrawalWallet} {__("Address")}
                            <span className="requried_icon">*</span>
                          </div>
                          <input
                            type="text"
                            value={withdrawalWalletAddress}
                            onChange={(ev) =>
                              setWithdrawalWalletAddress(ev.target.value)
                            }
                            className="input_box border_bottom "
                          />
                          {/* <i className="fal fa-copy in_input_icon"></i> */}
                        </div>
                        <div className="input_item">
                          <div className="name">
                            {__("Amount")}
                            <span className="requried_icon">*</span>
                          </div>
                          <div className="input-group">
                            <input
                              type="number"
                              className="input_box border_bottom "
                              aria-label="Recipient's username"
                              aria-describedby="basic-addon2"
                              value={withdrawalAmount}
                              onChange={(ev) =>
                                setWithdrawalAmount(ev.target.value)
                              }
                            />
                            <div className="currency_and_max_value">
                              <div className="currency_name">USD</div>
                              <div className="input-group-append">
                                <span
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    setWithdrawalAmount(
                                      userBalance.wallets[0].balance_fiat.replace(
                                        ",",
                                        ""
                                      )
                                    );
                                  }}
                                  className="input-group-text max_lavel"
                                  id="basic-addon2"
                                >
                                  {__("MAX")}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        {depositWallets[selectedWithdrawalWallet]?.tag && (
                          <div className="input_item">
                            <div className="name">
                              {__("Tag/Memo")}
                              <span className="requried_icon">*</span>
                            </div>
                            <div className="input-group">
                              <input
                                type="number"
                                className="input_box border_bottom "
                                value={withdrawalTag}
                                onChange={(ev) =>
                                  setWithdrawalTag(ev.target.value)
                                }
                              />
                            </div>
                          </div>
                        )}

                        {profile.twoFaEnabled && (
                          <div className="input_item">
                            <div className="name">
                              {__("Two FA Code")}
                              <span className="requried_icon">*</span>

                              <span>
                                {__(
                                  "Please enter the twofa code sent to your registered email."
                                )}
                              </span>
                            </div>
                            <div className="input-group">
                              <input
                                type="number"
                                className="input_box border_bottom "
                                value={twoFaCode}
                                onChange={(ev) => setTwoFaCode(ev.target.value)}
                              />
                            </div>

                            <a
                              style={{ color: "white" }}
                              href="#"
                              onClick={resend2FaCode}
                            >
                              {__("Get 2FA Code")}
                            </a>
                          </div>
                        )}

                        <div className="login_button">
                          <Link
                            disabled={
                              withdrawalAmount < 50 || !withdrawalWalletAddress
                            }
                            onClick={withdraw}
                            className={
                              withdrawalAmount < 50 || !withdrawalWalletAddress
                                ? "angle_btn text-center  inactive"
                                : "angle_btn text-center "
                            }
                          >
                            {withdrawalAmount >= 50
                              ? "Withdraw $" + withdrawalAmount
                              : "Min amount is $50.00"}
                          </Link>
                        </div>
                      </div>
                    </Tab>
                    <Tab eventKey="fiat-currency" title={__("Fiat Currency")}>
                      <div className="slideUpAnimation">
                        <FiatWithdrawals {...props} />
                      </div>
                    </Tab>
                  </Tabs>
                </>
              )}

              {activeWalletTab === "buy_crypto" && (
                <>
                  <div className="privacy_text bordered_text">&nbsp;</div>
                  <div className="form_area slideUpAnimation">
                    <div
                      style={{
                        justifyContent: "center",
                        padding: "15",
                        width: "800px",
                        maxWidth: "90vw",
                      }}
                    >
                      <iframe
                        style={{
                          borderRadius: 10,
                          boxShadow: "0 2px 10px 0 rgba(0,0,0,.20)",
                          margin: "auto",
                          width: "100%",
                          maxWidth: "90vw",
                          height: "660px",
                        }}
                        src={onRamperWidgetUrl}
                        title="Onramper widget"
                        frameBorder="0"
                        allow="accelerometer; autoplay; camera; gyroscope; payment"
                      ></iframe>
                    </div>
                  </div>
                </>
              )}

              {activeWalletTab === "bank_deposit" && (
                <>
                  {bankDepositUrl ? (
                    <>
                      <div className="privacy_text bordered_text">&nbsp;</div>
                      <div className="form_area slideUpAnimation">
                        <div
                          style={{
                            justifyContent: "center",
                            padding: "15",
                            width: "800px",
                            maxWidth: "90vw",
                          }}
                        >
                          <iframe
                            style={{
                              borderRadius: 10,
                              boxShadow: "0 2px 10px 0 rgba(0,0,0,.20)",
                              margin: "auto",
                              width: "100%",
                              maxWidth: "90vw",
                              height: "660px",
                            }}
                            src={bankDepositUrl}
                            frameBorder="0"
                          ></iframe>
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="form_area slideUpAnimation">
                      <div className="input_item">
                        <div className="name">
                          {__("Amount")}
                          <span className="requried_icon">*</span>
                        </div>
                        <input
                          type="number"
                          min="0"
                          step="1"
                          value={bankDepositAmount}
                          onChange={(ev) =>
                            setBankDepositAmount(ev.target.value)
                          }
                          className="input_box border_bottom "
                        />
                        {/* <i className="fal fa-copy in_input_icon"></i> */}
                      </div>

                      <div className="login_button">
                        <Link
                          onClick={initBankDeposit}
                          className={
                            "angle_btn small margin_0_auto " + props.landingType
                          }
                        >
                          {__("Deposit")}
                        </Link>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default CashierModals;
